"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAkitaBoxClient = void 0;
function createAttachmentsClient(api) {
    return {
        create: (...args) => api["attachmentsCreate"](...args),
        getByBuilding: (...args) => api["attachmentsGetByBuilding"](...args)
    };
}
function createDocumentsClient(api) {
    return {
        getByOrganization: (...args) => api["documentsGetByOrganization"](...args),
        upload: (...args) => api["documentsUpload"](...args)
    };
}
function createAkitaBoxClient(api) {
    return {
        attachments: createAttachmentsClient(api),
        documents: createDocumentsClient(api)
    };
}
exports.createAkitaBoxClient = createAkitaBoxClient;
//# sourceMappingURL=akitaBoxClient.js.map